import request from '../utils/request';

export async function addAndUpdateTestCapability(data) {
  return request.post('/vendor/addAndUpdateTestCapability', data);
}

export async function getTestCapability() {
  return request.get('/vendor/getTestCapability');
}

export async function deleteTestCapability(data) {
  return request.post('/vendor/deleteTestCapability', data);
}

export async function addAndUpdatePersosnnelAbility(data) {
  return request.post('/vendor/addAndUpdatePersosnnelAbility', data);
}

export async function getPersosnnelAbility() {
  return request.get('/vendor/getPersosnnelAbility');
}

export async function deletePersosnnelAbility(data) {
  return request.post('/vendor/deletePersosnnelAbility', data);
}

export async function addAndUpdateVendorCtsfm(data) {
  return request.post('/vendor/addAndUpdateVendorCtsfm', data);
}

export async function getVendorCtsfm() {
  return request.get('/vendor/getVendorCtsfm');
}

export async function deleteVendorCtsfm(data) {
  return request.post('/vendor/deleteVendorCtsfm', data);
}

export async function addAndUpdateVendorDieCasting(data) {
  return request.post('/vendor/addAndUpdateVendorDieCasting', data);
}

export async function getVendorDieCasting() {
  return request.get('/vendor/getVendorDieCasting');
}

export async function deleteVendorDieCasting(data) {
  return request.post('/vendor/deleteVendorDieCasting', data);
}

export async function addAndUpdateVendorInjection(data) {
  return request.post('/vendor/addAndUpdateVendorInjection', data);
}

export async function getVendorInjection() {
  return request.get('/vendor/getVendorInjection');
}

export async function deleteVendorInjection(data) {
  return request.post('/vendor/deleteVendorInjection', data);
}

export async function addAndUpdateVendorSmtSection(data) {
  return request.post('/vendor/addAndUpdateVendorSmtSection', data);
}

export async function getVendorSmtSection() {
  return request.get('/vendor/getVendorSmtSection');
}

export async function addVendorAssemblySection(data) {
  return request.post('/vendor/addVendorAssemblySection', data);
}

export async function getVendorAssemblySection() {
  return request.get('/vendor/getVendorAssemblySection');
}

export async function addAndUpdateVendorSurfaceTreatment(data, qid) {
  return request.post(`/vendor/addAndUpdateVendorSurfaceTreatment?qid=${qid}`, data);
}

export async function getVendorSurfaceTreatment() {
  return request.get('/vendor/getVendorSurfaceTreatment');
}
